import React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { Pace, Pause, WindupChildren } from 'windups';

import { JobSummary } from '@/graphql/generated';

import { messages as DEMessages } from '../../../../../../i18n/locales/de.js';
import { messages as ENmessages } from '../../../../../../i18n/locales/en.js';

import { Introduction, JobSummaryList, JobSummaryListItem, SectionHeader } from './job-summary-content.styles';

type JobSummaryProps = {
  language?: 'de' | 'en';
  skipAnimation?: boolean;
  summary: JobSummary;
  onAnimationEnd: () => void;
};

const WORD_PACE = 20; // 20ms pause when a word is finished
const SECTION_PAUSE = 200; // 200ms pause between sections
const LIST_ITEM_PAUSE = 100; // 100ms pause between list items

export const JobSummaryContent: React.FC<JobSummaryProps> = ({
  language = 'de',
  skipAnimation = false,
  summary,
  onAnimationEnd,
}) => (
  <IntlProvider locale={language} key={language} messages={language === 'de' ? DEMessages : ENmessages}>
    <WindupChildren skipped={skipAnimation} onFinished={onAnimationEnd}>
      <Pace getPace={(char) => (char === ' ' ? WORD_PACE : 0)}>
        <Introduction>{summary.content.introduction}</Introduction>
        <Pause ms={SECTION_PAUSE} />
        <SectionHeader size="medium">
          <FormattedMessage id="JOBS_DETAIL_AI_SUMMARY_KEY_RESPONSIBILITIES_SECTION_HEADER" />
        </SectionHeader>
        <JobSummaryList>
          {summary.content.keyResponsibilities.map((responsibility, index, responsibilities) => (
            <JobSummaryListItem key={index}>
              {responsibility}
              <Pause ms={index < responsibilities.length ? LIST_ITEM_PAUSE : 0} />
            </JobSummaryListItem>
          ))}
        </JobSummaryList>
        <Pause ms={SECTION_PAUSE} />
        <SectionHeader size="medium">
          <FormattedMessage id="JOBS_DETAIL_AI_SUMMARY_QUALIFICATIONS_SECTION_HEADER" />
        </SectionHeader>
        <JobSummaryList>
          {summary.content.qualifications.map((qualification, index, qualifications) => (
            <JobSummaryListItem key={index}>
              {qualification}
              <Pause ms={index < qualifications.length ? LIST_ITEM_PAUSE : 0} />
            </JobSummaryListItem>
          ))}
        </JobSummaryList>
      </Pace>
    </WindupChildren>
  </IntlProvider>
);
